import React, {useEffect, useMemo, useState} from 'react';
import MaterialReactTable, {MRT_ColumnDef, MRT_Row, MRT_TableInstance} from 'material-react-table';
import {EuiProgress} from "@elastic/eui";
import "./Topbar.css"
interface Credit {
    "paymentId": number,
    "paymentTransaction": number,
    "date": string
}

const PaymentComponent: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [credits, setCredits] = useState<Credit[]>([]);


    useEffect(() => {
        const fetchCredits = async () => {
            try {
               
                const token = localStorage.getItem('token');
                
                const response = await fetch('/api/v1/payment', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setCredits(data);
                } else {
                    console.error('API Error:', response.status);
                }
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCredits();
    }, []);

    const columns = useMemo<MRT_ColumnDef<Credit>[]>(
        () => [
            {
                header: 'Id',
                accessorKey: 'paymentId',


            },{
                header: 'Transaction amount',
                accessorKey: 'paymentTransaction'
            },
            {
                header: 'date',
                accessorKey: 'date',
                //  enableGrouping: false, //do not let this column be grouped

            },


        ],
        [],
    );





    return (
        <>
            <div className="top-bar-inside">
                <div className="containeroftopbar">
                    <div className="logo-inside">Payment History</div>
                </div>
            </div>
            {isLoading ?  <EuiProgress size="xs" color="accent" />:(
                <MaterialReactTable
                    enablePagination={false}
                    columns={columns}
                    data={credits}
                    enableGrouping
                    enableStickyHeader
                    enableStickyFooter
                    enablePinning
                    enableColumnOrdering = {true}
                    enableExpandAll={true}

                    initialState={{

                        density: 'compact',
                        

                    }
                    }

                    muiToolbarAlertBannerChipProps={{ color: 'primary' }}
                    muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                />)}
        </>
    );
};

export default PaymentComponent;